import { ErrorMessage, FormikHandlers, FormikValues } from 'formik';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Col } from 'reactstrap';
import CheckboxInput from 'src/components/UI/CheckboxInput';
import ErrorText from 'src/components/UI/ErrorText';
import { ConvertIsoStringWithTime, formatDateTimeFormServerView, formatUtcNewForEditWithTime, hasAdminOrEmployeeRoleHandler, hasCustomerRoleHandler, hasDealerRoleHandler, hasFranchiseRoleHandler, hasFranchiseSubuserRoleHandler } from 'src/helpers/common_helpers';
import { CHECK_VALUE_IN_ARRAY } from 'src/helpers/jobsheet_validation';
import { clearFaultySystem, updateFaultySystemLoading } from 'src/store/actions';
import FeatherIcon from "feather-icons-react";
import { RootReducerState } from 'src/store/reducers';

interface FaultySystemProps {
  values: FormikValues;
  handleChange: FormikHandlers['handleChange'];
  handleBlur: FormikHandlers['handleBlur'];
  id: any;
  validationConfiguration?: any;
  rest: any; // Can be more specific if needed (e.g., Input props)
  disabledForDealer: any[];
  setFieldValue:any;
  isJobView?:boolean;
  jobStatus?:any[];
}

const FaultySystem = ({values,handleChange,id,validationConfiguration,handleBlur,rest,disabledForDealer,setFieldValue,isJobView=false,jobStatus=[]}:FaultySystemProps) => {
      const { faultySystemResponse,defectivePartsData } = useSelector((state: RootReducerState) => state.jobsheetReducer);
  const [scanParts,setScanParts]= useState([])
            const hasAccess = (data:any)=>{
              if(data.userType == "Employee" && hasAdminOrEmployeeRoleHandler()){
                return true
              }else if(data.userType == "Franchise" && (hasFranchiseRoleHandler() || hasFranchiseSubuserRoleHandler())){
                return true
              }else if(data.userType == "Dealer" && hasDealerRoleHandler()){
                return true
              }else{
                return false
              }
            }
useEffect(()=>{
  let filteredData = defectivePartsData?.length > 0 ? defectivePartsData?.filter((data:any)=>data.isDeleted != true && data.id !=0 && hasAccess(data)) : []
  debugger
    setScanParts(filteredData)
},[defectivePartsData])

const newDateRef = useRef<Date | null>(null);
const [, forceUpdate] = useState(false);
    const dispatch = useDispatch()

      useEffect(()=>{
        if(faultySystemResponse?.length >0){
          faultySystemResponse?.forEach((faultySystem:any,index:any)=>{
            setFieldValue(`faultySystemAvailableList[${index}].isFaultySystem`,faultySystem.isFaultySystem ? true : false)
            setFieldValue(`faultySystemAvailableList[${index}].isSendFromMel`,faultySystem.isSendFromMel ? true : false)
            setFieldValue(`faultySystemAvailableList[${index}].isDelivered`,faultySystem.isDelivered ? true : false)
            setFieldValue(`faultySystemAvailableList[${index}].isReplace`,faultySystem.isReplace ? true : false)
            setFieldValue(`faultySystemAvailableList[${index}].partReplacedDate`,faultySystem.partReplacedDate ? formatUtcNewForEditWithTime(faultySystem.partReplacedDate) : "")
            setFieldValue(`faultySystemAvailableList[${index}].partSentFromMelDate`,faultySystem.partSentFromMelDate ? formatUtcNewForEditWithTime(faultySystem.partSentFromMelDate) : "")
            setFieldValue(`faultySystemAvailableList[${index}].partDeliveredDate`,faultySystem.partDeliveredDate ? formatUtcNewForEditWithTime(faultySystem.partDeliveredDate) : "")
          })
          dispatch(clearFaultySystem())
        }
      },[faultySystemResponse])

  return (
          <Col lg={8} md={12} className="mb-2 mt-3 align-items-center">
            <b className="header mb-2">Outgoing Courier Tracking</b>
            <div className="card ps-0 pe-0 " id="table-border">
            <DataTable
              value={values.faultySystemAvailableList}
              showGridlines
            //   style={{maxWidth:"800px"}}
            >
              <Column field="awbNumber" header="Courier" body={(rowData) => <b>{rowData.awbNumber}</b>} />
        
        {[
          { field: 'isSendFromMel', label: 'Courier Pickup Done', isDate: false },
          { field: 'partSentFromMelDate', label: 'Courier Pickup Date', isDate: true, dependency: 'isSendFromMel' },
          { field: 'isDelivered', label: 'Delivered', isDate: false },
          { field: 'partDeliveredDate', label: 'Delivered Date', isDate: true, dependency: 'isDelivered' },
          { field: 'isReplace', label: 'Replaced', isDate: false },
          { field: 'partReplacedDate', label: 'Replaced Date', isDate: true, dependency: 'isReplace' },
          { field: 'isFaultySystem', label: 'Faulty System Available', isDate: false },
        ].map(({ field, label, isDate, dependency }) => (
          <Column
            key={field}
            header={label}
            headerClassName="headerjobsheet"
            body={(rowData, options) => {
              const index = options.rowIndex;
        
              const {
                isSendFromMel,
                isDelivered,
                isReplace,
                isFaultySystem,
              } = rowData;
        
              const isDisabledByDependency =
                (field === 'isDelivered' && !isSendFromMel) ||
                (field === 'isReplace' && !isDelivered) ||
                (field === 'isFaultySystem' && !isReplace) || (isJobView == true && jobStatus.includes(values.status));
        
              if (!isDate) {
                return (
                  <div className='d-flex justify-content-center'>
                    <CheckboxInput
                      name={`faultySystemAvailableList[${index}].${field}`}
                      label=""
                      {...rest}
                      onChange={(e: any) => {
                        if (e.checked) {
                           if (field === 'isReplace' && scanParts.length === 0) {
    confirmDialog({
      header: (
        <div style={{ color: 'red', fontWeight: 'bold', fontSize: '1.1rem' }}>
          Action Not Allowed
        </div>
      ),
      message: (
        <div>
          <p>Please scan defected parts and update.</p>
        </div>
      ),
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'd-none', // hide accept button
      rejectClassName: 'd-none', // hide reject button
    });
    return; // Do not proceed
  }
                          confirmDialog({
                            header: `Confirmation ${label}`,
                            message: (
                              <div>
                                <p>Are you sure you want to mark <strong>{rowData.awbNumber}</strong> as <strong>{label}</strong>?</p>
                              </div>
                            ),
                            icon: 'pi pi-exclamation-triangle',
                            acceptClassName: 'p-button-danger',
                            accept: () => {
                              handleChange(e);
                              dispatch(
                                updateFaultySystemLoading(
                                  id,
                                  rowData.outgoingDispatchId,
                                  rowData.label,
                                  field
                                )
                              );
                            },
                          });
                        } else {
                          handleChange(e);
                        }
                      }}
                      onBlur={handleBlur}
                      value={rowData[field]}
                      required={false}
                      disabled={
                          rowData[field] || isDisabledByDependency || ((hasCustomerRoleHandler() || hasDealerRoleHandler()) ? disabledForDealer.includes(field) : false)
                      }
                    />
                    <ErrorMessage
                      name={`faultySystemAvailableList[${index}].${field}`}
                      component={ErrorText}
                    />
                  </div>
                );
              } else {
                const isEditable = (dependency ? rowData[dependency] : false) && !(isJobView == true && jobStatus.includes(values.status));
                const dateValue = rowData[field] != ""
                  ? formatDateTimeFormServerView( rowData[field],false)
                  : 'N/A';
        
                return (
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <span>{dateValue}</span>
                    {isEditable && (
                      <div className='job-icon'><FeatherIcon icon={"edit-2"} 
                      onClick={
                        ()=>{
                          newDateRef.current = rowData[field] ? rowData[field] : null;
                           confirmDialog({
                            header: `Change ${label}`,
                            message: (
                              <div className=''>
                                <p>Are you sure you want to change the <strong>{label}</strong>?</p>
                                <div>
                                   <Calendar
                                               name={field}
                                               inputId={label}
                                               id={label}
                                               value={newDateRef.current}
                                               onChange={(e: any) => {
                                                  newDateRef.current = e.value;
                                                  forceUpdate((prev) => !prev); // Force re-render
                                                }}
                                               className={`p-inputfield `}
                                               disabled={false}
                                               showIcon={true}
                                               dateFormat="dd-mm-yy"
                                               hourFormat="24"
                                               showButtonBar
                                               clearButtonClassName="calendar_button"
                                               todayButtonClassName="calendar_button"
                                               // minDate = {today && new Date() }
                                             />
                                </div>
                              </div>
                            ),
                            icon: 'pi pi-exclamation-triangle',
                            acceptClassName: 'p-button-danger',
                            accept: () => {
                              // handleChange(e);
                              if(newDateRef.current){
                                dispatch(
                                  updateFaultySystemLoading(
                                    id,
                                    rowData.outgoingDispatchId,
                                    rowData.label,
                                    field,
                                    "",
                                    ConvertIsoStringWithTime(newDateRef.current)
                                  )
                                );
                              }
                            },
                          });
                        }
                      }
                      /></div>
                    )}
                  </div>
                );
              }
            }}
          />
        ))}
        
            </DataTable>
            </div>
          </Col>
  )
}

export default FaultySystem